import { BaseBlockProps } from '../../defs/block';

export type PiggyBankBlockID = 'piggyBank';

export type PiggyBankBlockType = 'piggyBank';

export type PiggyBankBlockProps = {
  type: PiggyBankBlockType;
} & BaseBlockProps;

export const piggyBankBlockProps: Record<
  PiggyBankBlockID,
  PiggyBankBlockProps
> = {
  piggyBank: {
    id: 'pb',
    type: 'piggyBank',
    immobile: true,
    options: [{ count: 2 }, { count: 1 }],
    optionType: 'list',
  },
};
